import React from "react";
import Box from "@mui/material/Box";

const YOUTUBE = [
	/youtube\.com\/watch\?(?:[^#]*&)?v=([\w-]+)/,
	/youtu\.be\/([\w-]+)/,
	/youtube\.com\/embed\/([\w-]+)/,
	/youtube\.com\/shorts\/([\w-]+)/,
];
const VIMEO = /vimeo\.com\/(?:video\/)?(\d+)/;

export function toEmbedUrl(url?: any): string | null {
	if (url && typeof url === 'object') url = url.url;
	if (typeof url !== 'string' || !url) return null;
	// Chỉ chấp nhận http(s) để chặn href kiểu javascript:
	if (!/^https?:\/\//i.test(url) && !url.startsWith('/')) return null;
	for (const re of YOUTUBE) {
		const m = url.match(re);
		if (m) return `https://www.youtube.com/embed/${m[1]}`;
	}
	const v = url.match(VIMEO);
	if (v) return `https://player.vimeo.com/video/${v[1]}`;
	return null;
}

export default function VideoEmbed({ url, title }: { url?: any; title?: string }){
	if (url && typeof url === 'object') url = url.url;
	if (typeof url !== 'string' || !url) return null;
	// Chỉ chấp nhận http(s) để chặn href kiểu javascript:
	if (!/^https?:\/\//i.test(url) && !url.startsWith('/')) return null;

	const embed = toEmbedUrl(url);
	if (embed) {
		return <Box sx={{ position: "relative", paddingTop: "56.25%" }}>
			<iframe src={embed} title={title || ''} allowFullScreen
				style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", border: 0 }} />
		</Box>;
	}
	if (/\.(mp4|webm|ogg)(\?.*)?$/i.test(url)) {
		return <video controls src={url} style={{ width: "100%" }} />;
	}
	return <a href={url} target="_blank" rel="noopener noreferrer">Xem video</a>;
}
